import { BY_HELP_EMAIL, DEV_BY_HELP_EMAIL } from '@app/constants';

export async function clearBrowserStorage() {
  document.cookie.split(';').forEach((c) => {
    const isEmailCookie =
      c.startsWith(DEV_BY_HELP_EMAIL) || c.startsWith(BY_HELP_EMAIL);

    if (isEmailCookie) {
      return;
    }

    document.cookie = c
      .replace(/^ +/, '')
      .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`);
  });

  sessionStorage.clear();
  localStorage.clear();

  if ('caches' in window) {
    for (const key of await caches.keys()) await caches.delete(key);
  }

  if (indexedDB?.databases) {
    for (const db of await indexedDB.databases())
      indexedDB.deleteDatabase(db.name!);
  }
}
